var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarshmallows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7C7.41421 7 7.75 7.33579 7.75 7.75L7.75 10.25H8C9.51878 10.25 10.75 11.4812 10.75 13V20C10.75 21.5188 9.51878 22.75 8 22.75H7.75V25.25C7.75 25.6642 7.41421 26 7 26C6.58579 26 6.25 25.6642 6.25 25.25V22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V13C3.25 11.4812 4.48122 10.25 6 10.25H6.25V7.75C6.25 7.33579 6.58579 7 7 7ZM4.75 13C4.75 12.3096 5.30964 11.75 6 11.75H8C8.69036 11.75 9.25 12.3096 9.25 13V20C9.25 20.6904 8.69036 21.25 8 21.25H6C5.30964 21.25 4.75 20.6904 4.75 20V13Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C16.4142 12 16.75 12.3358 16.75 12.75L16.75 14.25H17C18.5188 14.25 19.75 15.4812 19.75 17V24C19.75 25.5188 18.5188 26.75 17 26.75H16.75V28.25C16.75 28.6642 16.4142 29 16 29C15.5858 29 15.25 28.6642 15.25 28.25V26.75H15C13.4812 26.75 12.25 25.5188 12.25 24V17C12.25 15.4812 13.4812 14.25 15 14.25H15.25V12.75C15.25 12.3358 15.5858 12 16 12ZM13.75 17C13.75 16.3096 14.3096 15.75 15 15.75H17C17.6904 15.75 18.25 16.3096 18.25 17V24C18.25 24.6904 17.6904 25.25 17 25.25H15C14.3096 25.25 13.75 24.6904 13.75 24V17Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 4C25.4142 4 25.75 4.33579 25.75 4.75V7.25H26C27.5188 7.25 28.75 8.48122 28.75 10V17C28.75 18.5188 27.5188 19.75 26 19.75H25.75V24.25C25.75 24.6642 25.4142 25 25 25C24.5858 25 24.25 24.6642 24.25 24.25V19.75H24C22.4812 19.75 21.25 18.5188 21.25 17V10C21.25 8.48122 22.4812 7.25 24 7.25H24.25V4.75C24.25 4.33579 24.5858 4 25 4ZM22.75 10C22.75 9.30964 23.3096 8.75 24 8.75H26C26.6904 8.75 27.25 9.30964 27.25 10V17C27.25 17.6904 26.6904 18.25 26 18.25H24C23.3096 18.25 22.75 17.6904 22.75 17V10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarshmallows);
export default __webpack_public_path__ + "static/media/marshmallows.0aab87b3b432a765bf296928f4c1c9a2.svg";
export { ForwardRef as ReactComponent };